export const PROXY_AMBIRE_ACCOUNT = '0x0F2AA7bcda3d9D210dF69a394b6965CB2566c828'
export const AMBIRE_ACCOUNT_FACTORY = '0x26cE6745A633030A6faC5e64e41D21fb6246dc2d'
export const AMBIRE_PAYMASTER = '0xA8B267C68715FA1Dca055993149f30217B572Cf0'
export const AMBIRE_PAYMASTER_SIGNER = '0x39f1B4be409F2DFC8FCB84C1196537728df727f3'
export const ERC_4337_ENTRYPOINT = '0x0000000071727De22E5E9d8BAf0edAc6f37da032'
export const ENTRY_POINT_MARKER =
  '0x0000000000000000000000000000000000000000000000000000000000007171'
export const MAX_UINT256 =
  115792089237316195423570985008687907853269984665640564039457584007913129639935n
export const MAX_UINT160 = 1461501637330902918203684832716283019655932542975n

export const PROXY_AMBIRE_4337_ACCOUNT = '0xd590a2aBA89a590b15De795DE559e7166aC293eA'
export const SINGLETON = '0xce0042B868300000d44A59004Da54A005ffdcf9f'
export const OPTIMISTIC_ORACLE = '0x420000000000000000000000000000000000000F'
export const SCROLL_ORACLE = '0x5300000000000000000000000000000000000002'
export const DEPLOYLESS_SIMULATION_FROM = '0x0000000000000000000000000000000000000001'

export const EIP_7702_AMBIRE_ACCOUNT = '0x5A7FC11397E9a8AD41BF10bf13F22B0a63f96f6d'
export const EIP_7702_METAMASK = '0x63c0c19a282a1B52b07dD5a65b58948A07DAE32B'
export const EIP_7702_GRID_PLUS = '0x8D6220c9961E8DD1844108C854F514E120226E20'
export const EIP_7702_KATANA = '0x8226995E02C70293595E0634C5F89547EDb08126'
